import * as Sentry from '@sentry/react';

let initialized = false;

// Initializes Sentry if VITE_SENTRY_DSN is set. Safe to call when no DSN is
// configured — the rest of the SDK becomes a no-op so we can ship the wiring
// before the user has signed up for a Sentry account.
export function initSentry() {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  if (!dsn) {
    if (import.meta.env.PROD) {
      console.info('Sentry: VITE_SENTRY_DSN not set — error tracking disabled.');
    }
    return;
  }
  if (initialized) return;

  Sentry.init({
    dsn,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || import.meta.env.MODE,
    // Soft-launch posture: capture errors, no perf tracing, only record a
    // session replay on the rare turn where something breaks.
    tracesSampleRate: 0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    integrations: [
      Sentry.replayIntegration({
        // Don't redact text — internal soft launch, helpful to see what users typed.
        // Reconsider before any wider release.
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    // Skip dev errors to avoid polluting issues with hot-reload noise.
    enabled: import.meta.env.PROD,
  });

  initialized = true;
}

// Thin wrapper around captureException so callers don't import Sentry directly.
// Falls back to console.error when Sentry isn't initialized.
export function captureError(error, context) {
  if (initialized) {
    Sentry.captureException(error, context ? { extra: context } : undefined);
  } else {
    console.error('Captured error (Sentry not initialized):', error, context);
  }
}

export const ErrorBoundary = Sentry.ErrorBoundary;
